(() => {
  if (customElements.get('sohna-purchase-options')) return;
  class SohnaPurchaseOptions extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.form = this.closest('form');
      this.button = this.form?.querySelector('button[type="submit"][name="add"]');
      if (!this.form || !this.button) return;
      try { this.config = JSON.parse(this.querySelector('[data-purchase-config]').textContent); }
      catch { return; }
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.mode = 'one_time'; this.months = 1;
      this.controls = this.querySelector('[data-purchase-controls]');
      this.quantity = this.querySelector('[data-purchase-quantity]');
      this.plan = this.querySelector('[data-purchase-plan]');
      this.notice = this.querySelector('[data-purchase-notice]');
      this.buttonText = this.button.querySelector('.add-to-cart-text__content');
      this.addEventListener('change', event => {
        if (event.target.matches('[data-purchase-mode]')) this.mode = event.target.value;
        else if (event.target.matches('[data-purchase-months]')) this.months = Number(event.target.value);
        else return;
        this.update();
      }, { signal });
      // Guard the native form as well as the button; keyboard/requestSubmit must not bypass a gate.
      this.form.addEventListener('submit', event => {
        this.syncInputs();
        if (!this.canPurchase()) {
          event.preventDefault(); event.stopImmediatePropagation(); this.update();
        }
      }, { capture: true, signal });
      this.closest('.shopify-section')?.addEventListener('variant:update', event => {
        if (String(event.detail?.data?.sectionId || this.dataset.sectionId) !== this.dataset.sectionId) return;
        queueMicrotask(() => {
          this.config.variantId = this.form.querySelector('[name="id"]')?.value;
          this.mode = 'one_time'; this.months = 1; this.render();
        });
      }, { signal });
      this.render(); this.hidden = false;
      this.form.classList.add('sohna-purchase-form');
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
    get variant() { return this.config.variants[String(this.form.querySelector('[name="id"]')?.value || this.config.variantId)]; }
    get allocation() {
      return this.variant?.allocations?.find(a => String(a.selling_plan?.id) === this.config.sellingPlanId);
    }
    money(cents) { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: this.config.currency }).format(Math.round(cents) / 100); }
    canPurchase() {
      if (!this.variant?.available) return false;
      if (this.mode === 'subscription') return this.config.isSingle && this.config.subscriptionVerified && Boolean(this.allocation);
      return this.mode === 'one_time' && [1, 2, 3].includes(this.months) && (this.months === 1 || this.config.quantityOffersSuspended || this.config.quantityVerified);
    }
    syncInputs() {
      this.quantity.value = this.mode === 'subscription' ? '1' : String(this.months);
      this.plan.disabled = this.mode !== 'subscription' || !this.allocation;
      this.plan.value = this.plan.disabled ? '' : String(this.allocation.selling_plan.id);
    }
    render() {
      const price = this.variant?.price || 0;
      const id = `sohna-purchase-${this.dataset.sectionId}`;
      const subscriptionPrice = this.allocation?.price ?? Math.round(price * .85);
      this.controls.innerHTML = `
        <fieldset class="sohna-purchase__modes"><legend class="visually-hidden">Choisis ton achat</legend>
          <div class="sohna-purchase__option" data-one-time-option>
            <label class="sohna-purchase__heading">
              <input type="radio" name="${id}-mode" value="one_time" data-purchase-mode checked>
              <span class="sohna-purchase__title">Achat unique</span>
              <span class="sohna-purchase__summary">1 mois de cure <strong>${this.money(price)}</strong></span>
            </label>
            <fieldset class="sohna-purchase__durations"><legend class="visually-hidden">Durée de la cure</legend>
              ${[1, 2, 3].map(months => {
                const discount = this.config.quantityOffersSuspended ? 0 : months === 2 ? 10 : months === 3 ? 15 : 0;
                return `<label class="sohna-purchase__card">
                  <input type="radio" name="${id}-months" value="${months}" data-purchase-months ${months === 1 ? 'checked' : ''}>
                  <span class="sohna-purchase__card-body">${discount ? `<span class="sohna-purchase__badge">−${discount} %</span>` : ''}
                    <strong>${months} mois</strong>
                    <span class="sohna-purchase__card-price">${discount ? `<s>${this.money(price * months)}</s>` : ''}<strong>${this.money(price * months * (1 - discount / 100))}</strong></span>
                  </span>
                </label>`;
              }).join('')}
            </fieldset>
          </div>
          ${this.config.isSingle && this.config.subscriptionVerified ? `<div class="sohna-purchase__option" data-subscription-option>
            <label class="sohna-purchase__heading">
              <input type="radio" name="${id}-mode" value="subscription" data-purchase-mode>
              <span class="sohna-purchase__title">En abonnement <span class="sohna-purchase__saving">−15 % chaque mois</span></span>
              <span class="sohna-purchase__subscription-price"><s>${this.money(price)}</s><strong>${this.money(subscriptionPrice)}</strong><small>/ mois</small></span>
            </label>
            <p class="sohna-purchase__terms" hidden>1 cure livrée chaque mois · Livraison offerte.<br>Minimum 2 paiements réussis. Sans résiliation ni pause avant le deuxième paiement réussi.</p>
          </div>` : ''}
        </fieldset>
        <p class="sohna-purchase__availability"><span aria-hidden="true"></span>${this.variant?.available ? 'Disponible' : 'Indisponible'}</p>`;
      this.update();
    }
    update() {
      this.syncInputs();
      const subscription = this.mode === 'subscription';
      this.controls.querySelector('[data-one-time-option]').classList.toggle('is-selected', !subscription);
      this.controls.querySelector('[data-subscription-option]')?.classList.toggle('is-selected', subscription);
      this.controls.querySelector('.sohna-purchase__durations').hidden = subscription;
      const terms = this.controls.querySelector('.sohna-purchase__terms');
      if (terms) terms.hidden = !subscription;
      const available = this.variant?.available;
      const ready = this.canPurchase();
      const price = subscription ? (this.allocation?.price ?? this.variant?.price * .85) : this.variant?.price * this.months * (this.config.quantityOffersSuspended ? 1 : ({ 1: 1, 2: .9, 3: .85 }[this.months] ?? 1));
      const label = !available ? 'Indisponible' : ready ? `Ajouter au panier — ${this.money(price)}` : 'Bientôt disponible';
      if (this.buttonText) this.buttonText.textContent = label;
      this.button.setAttribute('aria-label', label);
      if (ready) this.button.removeAttribute('disabled');
      else this.button.setAttribute('disabled', 'true');
      this.notice.hidden = ready || !available;
      this.notice.textContent = 'Cette offre sera bientôt disponible.';
    }
  }
  customElements.define('sohna-purchase-options', SohnaPurchaseOptions);
})();
